/* eslint-disable indent */
import { clientbookApi } from '../core/clientbook-api';

function draftEndpoint(type) {
  switch (type) {
    case 'C':
      return 'chats';
    case 'I':
      return 'meta/instagram/chats';
    case 'F':
      return 'meta/facebook/chats';
    case 'G':
      return 'google/reviews';
    default:
      return 'chats';
  }
}

export const createUserDraft = async ({ chatId, message, type = 'C' }) => {
  return clientbookApi.post({
    url: `${draftEndpoint(type)}/${chatId}/drafts`,
    data: { message },
  });
};

export const updateUserDraft = async ({ chatId, message, draftId, type = 'C' }) => {
  return clientbookApi.put({
    url: `${draftEndpoint(type)}/${chatId}/drafts/${draftId}`,
    data: { message },
  });
};

export const deleteUserDraft = async ({ chatId, draftId, type = 'C' }) => {
  return clientbookApi.delete({
    url: `${draftEndpoint(type)}/${chatId}/drafts/${draftId}`,
  });
};

export const getUserDraft = async ({ chatId, associateId = null, type = 'C' }) => {
  return clientbookApi.get({
    url: `${draftEndpoint(type)}/${chatId}/drafts`,
    query: associateId
      ? {
        associateId,
      }
      : {},
  });
};
